import * as React from "react";
import { cn } from "lib/cn";
import { PreviewLink } from "@compass/shared/types";

export const MetaPreview = ({ preview }: { preview: PreviewLink }) => {
    return (
        <div
            className={cn(
                "flex max-h-36 w-full max-w-full gap-2 overflow-hidden rounded border border-gray-400 p-2",
                {
                    ["w-1/3"]: !preview.title,
                },
            )}
        >
            {preview.image && (
                <img
                    src={preview.image}
                    alt={preview.description ?? `Preview of ${preview.url}`}
                    className={cn(
                        "h-full max-w-[120px] flex-shrink-0 cursor-pointer rounded object-cover",
                        {
                            ["w-1/3"]: preview.title,
                        },
                    )}
                    onClick={() => window.open(preview.url, "_blank")}
                />
            )}
            <a
                className="flex min-w-0 flex-1 flex-col justify-center gap-1 overflow-hidden no-underline"
                href={preview.url}
                target="_blank"
                rel="noreferrer"
            >
                <span className="truncate text-lg font-medium text-black">{preview.title}</span>
                {preview.description && (
                    <span className="line-clamp-2 text-sm text-gray-700">
                        {preview.description}
                    </span>
                )}
            </a>
        </div>
    );
};
